import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// --- FIX: Import the necessary Google Auth functions ---
import { getAuth, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { db } from '../../firebase/config';
import { doc, getDoc, setDoc } from 'firebase/firestore'; // <-- Import setDoc
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  FormPageContainer,
  FormBox,
  FormTitle,
  Input,
  Button,
  GoogleButton, // <-- Import new styles
  Separator     // <-- Import new styles
} from '../common/Form.styles';

const roleRedirects = {
  admin: '/admin/dashboard',
  'data-entry': '/data-entry/dashboard',
  client: '/client/dashboard'
};

const Login = () => {
  const navigate = useNavigate();
  const auth = getAuth(); // Get the auth instance

  // --- NEW: Function to handle Google Sign-In ---
  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check if this user already exists in our Firestore 'users' collection
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);

      let userRole;

      if (userDoc.exists()) {
        // The user already exists, get their role
        userRole = userDoc.data().role;
      } else {
        // This is a NEW user, create a document for them in Firestore
        console.log("New user via Google, creating profile...");
        userRole = 'client'; // Default role for new sign-ups
        await setDoc(userDocRef, {
          clientName: user.displayName,
          email: user.email,
          role: userRole,
        });
      }

      // Redirect to the correct dashboard based on their role
      const redirectPath = roleRedirects[userRole] || '/login';
      toast.success("Login successful!");
      navigate(redirectPath);

    } catch (error) {
      toast.error("Failed to sign in with Google.");
      console.error("Google Sign-In Error:", error);
    }
  };

  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email').required('Required'),
      password: Yup.string().required('Required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      const loadingToast = toast.loading("Logging in...");
      try {
        const userCredential = await signInWithEmailAndPassword(auth, values.email, values.password);
        const user = userCredential.user;

        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userRole = userDoc.data().role;
          const redirectPath = {
            admin: '/admin/dashboard',
            'data-entry': '/data-entry/dashboard',
            client: '/client/dashboard'
          }[userRole] || '/login';
          toast.success("Login successful!", { id: loadingToast });
          navigate(redirectPath);
        } else {
          throw new Error("User data not found.");
        }
      } catch (error) {
        toast.error("Invalid credentials or user error.", { id: loadingToast });
        console.error("Login Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <FormPageContainer>
      <FormBox>
        <FormTitle>TallyDocs Login</FormTitle>
        <form onSubmit={formik.handleSubmit}>
          <Input name="email" type="email" placeholder="Email" onChange={formik.handleChange} value={formik.values.email} />
          <Input name="password" type="password" placeholder="Password" onChange={formik.handleChange} value={formik.values.password} />
          <Button type="submit" disabled={formik.isSubmitting}>Login</Button>
        </form>

        <Separator>OR</Separator>

        <GoogleButton type="button" onClick={handleGoogleSignIn}>
          {/* You can add a Google Icon SVG here later if you wish */}
          Sign in with Google
        </GoogleButton>
      </FormBox>
    </FormPageContainer>
  );
};

export default Login;